
import React from 'react';

interface HintProps {
  hintText: string;
}

const Hint: React.FC<HintProps> = ({
  hintText
}) => {
  return (
    <span className="hint-container">
      <span className="hint">?</span>
      <span className="hint-content">{hintText}</span>
    </span>
  );
};

export default Hint;